const LaunchIva = "LaunchIva";
const SwitchAcctIva = "SwitchAcctIva";
const ActiveCCSessonIVA = "ActiveCCSessonIVA";
const ManageAcctIva = "ManageAcctIva";
const DeepLinkReqCCTR = "DeepLinkReqCCTR";
const DeepLinkRespIva = "DeepLinkRespIva";
const PlatformAccountDataRefresh = "PlatformAccountDataRefresh";
// eslint-disable-next-line import/no-anonymous-default-export
export default { LaunchIva, SwitchAcctIva, ActiveCCSessonIVA, ManageAcctIva, DeepLinkReqCCTR, DeepLinkRespIva, PlatformAccountDataRefresh };
